export const envs = {
  API_HOST: process.env.NX_PUBLIC_API_HOST || '',
  PWA_NAME_PREFIX:
    process.env.NX_PUBLIC_ENV === 'production'
      ? void 0
      : process.env.NX_PUBLIC_TEST_DOMAIN || process.env.NX_PUBLIC_ENV,
  NX_PUBLIC_COMMIT: process.env.NX_PUBLIC_COMMIT,
  STATIC_ASSETS_URL: process.env.NX_PUBLIC_STATIC_ASSETS_URL,
  PATH: process.env.NX_PUBLIC_PATH || '',
  LAUNCHER_PATH: process.env.NX_PUBLIC_LAUNCHER_PATH || '',
  MY_TRACKER_ID: process.env.NX_PUBLIC_MY_TRACKER_ID || '',
  YA_METRIKA_ID: process.env.NX_PUBLIC_YA_METRIKA_ID || '',
  VK_MAIN_URL: process.env.NX_PUBLIC_VK_MAIN_URL || '',
  GOOGLE_PLAY_STORE_URL: process.env.NX_PUBLIC_GP_STORE_URL || '',
  APP_STORE_URL: process.env.NX_PUBLIC_APP_STORE_URL || '',
  BUILD_NUMBER: parseInt(process.env.NX_PUBLIC_BUILD_NUMBER || '0'),
};
